import { withStyles, Box } from '@material-ui/core';

export const LoaderWrapper = withStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    '& .loader': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      animation: '$wave 1.7s ease-out infinite',
    },
    '& .loader:before': {
      content: '',
      display: 'block',
      paddingTop: '100%',
    },
    '& .circular': {
      height: '100%',
      transformOrigin: 'center center',
      width: '100%',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: 'auto',
    },
    '& .border': {
      strokeDasharray: '200 200',
      stroke: 'rgba(255, 255, 255, 0.3)',
      animation: '$stroke 1.7s ease-out infinite',
    },
  },
  '@keyframes wave': {
    '60%': {
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.3)',
      opacity: 0,
    },
  },
  '@keyframes stroke': {
    '60%': {
      strokeWidth: 0.5,
      stroke: 'rgba(255, 255, 255, 0.7)',
    },
    '100%': {
      strokeWidth: 0.1,
      stroke: 'rgba(255, 255, 255, 1)',
    },
  },
})(Box);
